import { FooterContainer, CopyrightText, Actions, Button } from './styles';
import { useNavigate } from "react-router-dom";
import { userLogin } from "../../store/modules/login/actions";
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';
import { userService } from '../../services/userService';
import { hasUiSessionHint, persistUiSession } from '../../utils/authSession';

const hasPendingRegistration = (data) => (
  data
  && !Array.isArray(data)
  && typeof data === 'object'
  && Boolean(data.email)
);

const isLoggedIn = () => hasUiSessionHint();

const showLoginRequiredMessage = () => Swal.fire({
  title: 'Login necessário',
  text: 'Você precisa estar logado para aceitar os termos. A aceitação ficará registrada em sua conta.',
  icon: 'info',
  confirmButtonText: 'OK',
});

const AcceptanceBar = ({ path, func, registerUser }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const finalObject = useSelector((state) => state.app_data.user_first_access);

  const handleAccept = async () => {
    if (func) {
      func();
    }

    if (registerUser) {
      if (!hasPendingRegistration(finalObject)) {
        if (!isLoggedIn()) {
          await showLoginRequiredMessage();
          return;
        }

        navigate(path);
        return;
      }

      try {
        const response = await userService.registerUser(finalObject);

        // Signup pode ou não devolver cookies; persistimos só metadados de UI.
        persistUiSession(response);
        dispatch(userLogin(null, response, response?.id));

        Swal.fire({
          title: 'Sucesso!',
          text: 'Seu cadastro foi realizado com sucesso!',
          icon: 'success',
          confirmButtonText: 'OK'
        });

        navigate(path);
      } catch (error) {
        console.error('Erro ao registrar usuário:', error);
        Swal.fire({
          title: 'Erro!',
          text: 'Algo deu errado. Por favor, contate nosso suporte! suporte@vertecotech.com',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }

      return;
    }

    if (!hasPendingRegistration(finalObject) && !isLoggedIn()) {
      await showLoginRequiredMessage();
      return;
    }

    navigate(path);
  };

  const handleDecline = () => {
    navigate('/');
  };

  return (
    <FooterContainer>
      <CopyrightText>Copyright © 2024</CopyrightText>
      <Actions>
        <Button type="button" onClick={handleAccept}>Aceitar</Button>
        <Button type="button" onClick={handleDecline}>Declinar</Button>
      </Actions>
    </FooterContainer>
  );
};

export default AcceptanceBar;
